import React, { Fragment } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Divider from "@mui/material/Divider";
import List from "@mui/material/List";
import NavigationMenuHeading from "manager-panel/NavigationMenuHeading";
import NavigationMenuLink from "manager-panel/NavigationMenuLink";
import { useSelector } from "react-redux";

import withAuthorization from "auth/withAuthorization";
import { hasAdminRole } from "../auth/authUtils";

const MenuItem = withAuthorization(NavigationMenuLink, false);
const AuthorizedMenuHeader = withAuthorization(NavigationMenuHeading, false);

const useStyles = makeStyles(theme => ({
  root: {
    marginTop: 135,
    overflowY: "auto",
  },
}));

const NavigationPanel = ({ onClose }) => {
  const classes = useStyles();
  const auth = useSelector(state => state.auth);

  const AuthorizedMenuItem = props => {
    return <MenuItem {...props} onClick={onClose} />;
  };

  return (
    <div className={classes.root}>
      {hasAdminRole(auth.user) && (
        <Fragment>
          <List>
            <AuthorizedMenuItem
              to="/home"
              roles={["ROLE_ADMIN"]}
              primary="Dashboard"
            />
            <AuthorizedMenuItem
              to="/manage-organizations/organizations"
              roles={["ROLE_ADMIN"]}
              primary="Organizations"
            />
            <AuthorizedMenuItem
              to="/manage-authentication"
              roles={["ROLE_ADMIN"]}
              primary="Manage Authentication"
            />
            <AuthorizedMenuItem
              to="/manage-subscriptions"
              roles={["ROLE_ADMIN"]}
              primary="Manage Subscriptions"
            />
            <AuthorizedMenuItem
              to="/manage-application-accounts"
              roles={["ROLE_ADMIN"]}
              primary="Application Accounts"
            />
            <AuthorizedMenuItem
              to="/manage-csp/programs"
              roles={["ROLE_ADMIN"]}
              primary="Manage CSPs"
            />

            <AuthorizedMenuItem
              to="/manage-badges"
              roles={["ROLE_ADMIN"]}
              primary="Manage Badges"
            />

            <AuthorizedMenuItem
              to="/user-admin/users"
              roles={["ROLE_ADMIN"]}
              primary="User Administration"
            />

            <AuthorizedMenuItem
              to="/content-providers"
              roles={["ROLE_ADMIN"]}
              primary="Manage Content Providers"
            />

            <AuthorizedMenuItem
              to="/manage-module-groups"
              roles={["ROLE_ADMIN", "ROLE_CONTENT_MANAGER"]}
              primary="Manage Module Groups"
            />
          </List>

          <Divider />

          <List>
            <AuthorizedMenuHeader
              primary="CADIE Management"
              roles={["ROLE_ADMIN"]}
            >
              <AuthorizedMenuItem
                to="/content-ingestion-report"
                roles={["ROLE_ADMIN"]}
                primary="Contgent Ingestion Report"
              />
            </AuthorizedMenuHeader>
          </List>

          <Divider />
        </Fragment>
      )}

      <List>
        <AuthorizedMenuHeader
          primary="Creator"
          expand
          roles={[
            "ROLE_ADMIN",
            "ROLE_CONTENT_MANAGER",
            "ROLE_CREATOR_USER",
            "ROLE_CREATOR_MANAGER",
            "ROLE_IAP_REVIEWER",
          ]}
        >
          <AuthorizedMenuItem
            to="/creator/home"
            roles={[
              "ROLE_ADMIN",
              "ROLE_CONTENT_MANAGER",
              "ROLE_CREATOR_USER",
              "ROLE_CREATOR_MANAGER",
            ]}
            primary="Dashboard"
          />
          <AuthorizedMenuItem
            to="/creator/organize"
            roles={[
              "ROLE_ADMIN",
              "ROLE_CONTENT_MANAGER",
              "ROLE_CREATOR_USER",
              "ROLE_CREATOR_MANAGER",
              "ROLE_IAP_REVIEWER",
            ]}
            primary="Workbench"
          />

          {hasAdminRole(auth.user) && (
            <Fragment>
              <AuthorizedMenuItem
                to="/creator/modules"
                roles={[
                  "ROLE_ADMIN",
                  "ROLE_CONTENT_MANAGER",
                  "ROLE_CREATOR_USER",
                  "ROLE_CREATOR_MANAGER",
                ]}
                primary="Modules"
              />
              <AuthorizedMenuItem
                to="/creator/anthologies"
                roles={[
                  "ROLE_ADMIN",
                  "ROLE_CONTENT_MANAGER",
                  "ROLE_CREATOR_USER",
                  "ROLE_CREATOR_MANAGER",
                ]}
                primary="Anthologies"
              />
              <AuthorizedMenuItem
                to="/creator/collections"
                roles={[
                  "ROLE_ADMIN",
                  "ROLE_CONTENT_MANAGER",
                  "ROLE_CREATOR_USER",
                  "ROLE_CREATOR_MANAGER",
                ]}
                primary="Collections"
              />
              <AuthorizedMenuItem
                to="/creator/content"
                roles={[
                  "ROLE_ADMIN",
                  "ROLE_CONTENT_MANAGER",
                  "ROLE_CREATOR_USER",
                  "ROLE_CREATOR_MANAGER",
                ]}
                primary="Content"
              />
            </Fragment>
          )}
        </AuthorizedMenuHeader>
      </List>

      {hasAdminRole(auth.user) && (
        <Fragment>
          <Divider />

          <List>
            <AuthorizedMenuHeader
              primary="Security Settings"
              roles={["ROLE_ADMIN"]}
            >
              <AuthorizedMenuItem
                to="/region-ip-override"
                roles={["ROLE_ADMIN"]}
                primary="IP Region Overrides"
              />
              <AuthorizedMenuItem
                to="/sip-servers"
                roles={["ROLE_ADMIN"]}
                primary="SIP Servers"
              />
              <AuthorizedMenuItem
                to="/papi-servers"
                roles={["ROLE_ADMIN"]}
                primary="Patron API Servers"
              />
              <AuthorizedMenuItem
                to="/sftp-accounts"
                roles={["ROLE_ADMIN"]}
                primary="SFTP Accounts"
              />
            </AuthorizedMenuHeader>
          </List>
        </Fragment>
      )}
    </div>
  );
};

export default NavigationPanel;
